module.exports = __webpack_public_path__ + "fonts/IstokWeb-BoldItalic.2507c78b.eot";